
<template>
<b-row class="tedft-navigation no-gutters">
    <b-col cols="12">
        <div class="div-lg">
            <b-row class="no-gutters main-row ">

                <!--left-->
                <b-col class="" md="3" lg="2" cols="12">
                    <b-row class="left-nav-sec no-gutters">
                        <b-col v-show="show(navButtons, 'back')" class="left-btn  reduce-padding">
                            <button @click="back()" class="back-btn btn">
                            <span class="back-icon"></span>
                            <span class="btn-text">BACK</span>
                        </button>
                        </b-col>

                    </b-row>

                </b-col>

                <b-col class="" v-show="show(navButtons, 'showMidCol') && !showspecialist" md="3" lg="6" cols="12">
                    <b-row class="mid-nav-sec no-gutters" >
                        <b-col class="reduce-padding" v-show="isShowTedBtn" >
                          <button @click="openTedPopup()" class="what-ted-btn  btn">
                            <span class="btn-text-l">WHAT IS A TED “FLARE?”</span>
                        </button>
                        </b-col>

                    </b-row>

                </b-col>

                <b-col v-if="show(navButtons, 'next') && !showspecialist" class="" md="6" lg="4" cols="12">
                    <b-row class="right-nav-sec no-gutters">
                        <b-col class="right-btn reduce-padding">

                                <button @click="next()" class="forward-btn btn">
                                   <span class="btn-text nxt-text">NEXT</span>
                                <span class="next-icon"></span>
                                    </button>


                            <router-link :to="{path: '/'+'menu'}" exact v-if="!isHideMenu">
                                <button class="menu-btn btn" @click="tagMenu">
                                   <span class="btn-text nxt-text">MENU</span>
                                    </button>
                            </router-link>
                        </b-col>



                    </b-row>

                </b-col>

                <b-col v-if="showspecialist" class="" md="9" lg="10" cols="12">
                    <b-row class="right-nav-sec no-gutters">
                        <b-col cols="12">
                            
                            <div class="specialist next-btn no-gutters">
                                <a href="https://www.thyroideyes.com/find-a-thyroid-eye-disease-specialist" @click="tagLink" target="_blank" class="specialist-btn">
                        FIND A TED EYE SPECIALIST</a>
                            </div>
                            
                               <router-link  :to="{path: '/'+'menu'}" exact v-if="!isHideMenu">
                                <button class="menu-btn btn" @click="tagMenu">
                                   <span class="btn-text nxt-text">MENU</span>
                                    </button>
                            </router-link>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </div>


        <b-row class="no-gutters main-row div-sm">
            

            <b-col v-show="show(navButtons, 'next') && !showspecialist" class="" md="3" lg="2" cols="12">
                <b-row class="right-nav-sec no-gutters">

                   
                    <b-col class="right-btn reduce-padding">
                   
                            <!--<router-link :to="{path: '/'+nextPage}" exact>-->
                                <button @click="next()" class="forward-btn btn">
                                   <span class="btn-text nxt-text">NEXT</span>
                                <span class="next-icon"></span>
                                    </button>
                            <!--</router-link>-->

                    </b-col>
                </b-row>
            </b-col>
            
            

            <b-col class="" md="3" lg="2" cols="12">
                <b-row class="left-nav-sec no-gutters">
                    <b-col v-show="show(navButtons, 'back')" class="left-btn  reduce-padding">
                            <button @click="back()" class="back-btn btn">
                            <span class="back-icon"></span>
                            <span class="btn-text">BACK</span>
                        </button>
                        </b-col>

                </b-row>
            </b-col>
            
              <b-col v-show="show(navButtons, 'next') && !showspecialist" class="" md="3" lg="2" cols="12">
                <b-row class="right-nav-sec no-gutters">

                   
                    <b-col class="right-btn reduce-padding">
                        <router-link :to="{path: '/'+'menu'}" exact v-if="!isHideMenu">
                            <button class="menu-btn btn" @click="tagMenu"><span class="btn-text-m">MENU</span></button>
                            </router-link>
                    </b-col>
                </b-row>
            </b-col>
            
              <b-col v-show="showspecialist" class="" md="9" lg="10" cols="12">
                <b-row class="right-nav-sec no-gutters">
                    <b-col cols="12">
                        <router-link :to="{path: '/'+'menu'}" exact v-if="!isHideMenu " >
                                <button class="menu-btn btn" @click="tagMenu">
                                   <span class="btn-text-m">MENU</span>
                                    </button>
                            </router-link>
                    </b-col>
                </b-row>
            </b-col>

            <b-col v-show="showspecialist" class="" md="9" lg="10" cols="12">
                <b-row class="right-nav-sec no-gutters">
                    <b-col cols="12">
                        <div class="specialist next-btn no-gutters">
                            <a href="https://www.thyroideyes.com/find-a-thyroid-eye-disease-specialist" @click="tagLink" target="_blank" class="specialist-btn">
                        FIND A TED EYE SPECIALIST</a>
                        </div>
                    </b-col>
                </b-row>
            </b-col>

            <b-col class="" v-show=" !showspecialist" md="6" lg="8" cols="12">
                 <b-row class="mid-nav-sec no-gutters" >
                        <b-col class=" reduce-padding" v-show="isShowTedBtn" >
                          <button @click="openTedPopup()" class="what-ted-btn  btn">
                            <span class="btn-text-l">WHAT IS A TED “FLARE?”</span>
                        </button>
                        </b-col>

                    </b-row>
            </b-col>
        </b-row>
    </b-col>
</b-row>
 </template>

<script>
    /* eslint-disable */
import taggingMixin from "../mixins/taggingMixin";
    import { mapGetters } from 'vuex';

    export default {

        name: 'tedftNavigation',
        mixins: [taggingMixin],
        components: {},
        data() {
            return {
                screens: ['/', 'menu', 'background', 'riskFactors', 'tedFlares', 'tedFlares2', 'tedFlares3', 'tedFlares4', 'tedFlares5',
                    'summary'
                ]
            };
        },
        props: {
            navButtons: {
                type: Array
            },

            currentScreen: {
                type: Number
            },

            showspecialist: {
                type: Boolean,
                default: false,
            },

            isHideMenu: {
                type: Boolean,
                default: false,
            },



            isSymptom: {
                type: Boolean,
                default: false,
            },
            isShowTedBtn: {
                type: Boolean,
                default: false,
            },

            isMenuPage: {
                type: Boolean,
                default: false,
            }

        },

        computed: {
            ...mapGetters('userData', ['userData'])
        },

        mounted: function() {
            // Send page views
            var url = window.location.href;
             var obj={ 
            'hitType': 'pageview', 
             'page': this.$route.path, 
             'title': this.$route.path.split("/")[1] , 
             'location': url.replace(/#.*$/, '')+'#/'+this.$route.path.split("/")[1]
            };
            try {
              console.log("sending Message:", JSON.stringify(obj));
              window.top.postMessage(JSON.stringify(obj), "*");
            } catch(e) {
              console.log("error sending Message");
            }
        },

        methods: {

            openTedPopup: function() {
                this.tagNav('What is a TED Flare? Button', this.screens[this.currentScreen]);
                this.userData.isWhatTed = true
            },

            show: function(buttonsArray, button) {
                return !(buttonsArray.indexOf(button) == -1);
            },

            next: function() {
                var nextScreen;
                nextScreen = this.screens[this.currentScreen + 1];
                this.tagNav('Next Button', this.screens[this.currentScreen]);
                this.$router.push(nextScreen);
            },

            back: function() {
                if (this.isMenuPage) {
                    this.$router.push('getStarted');
                }
                else {
                    var backScreen = this.screens[this.currentScreen - 1];
                    setTimeout(() => {
                        this.tagNav('Back Button', this.screens[this.currentScreen]);
                        this.$router.push(backScreen);
                        // this.$router.go(-1);
                    }, 0);
                }

            },

            tagLink: function() {
                var obj={ 
                hitType: 'event',
                eventCategory: 'TED External Link',
                eventAction: 'FIND A TED EYE SPECIALIST Link Click',
                eventLabel: 'https://www.thyroideyes.com/find-a-thyroid-eye-disease-specialist'
                };
                try {
                  console.log("sending Message:", JSON.stringify(obj));
                  window.top.postMessage(JSON.stringify(obj), "*");
                } catch(e) {
                  console.log("error sending Message");
                }
            },
            
            tagMenu: function() {
                this.tagNav('Menu Button', this.screens[this.currentScreen]);
                this.$router.push('menu');
            }


        },


    };
</script>

<style scoped>
</style>
 